// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"9ef7a210","469":"00d0a522"}[chunkId] + ".chunk.js";
};